// https://github.com/vuejs/Discussion/issues/405#issuecomment-287371191
export function mapFilters(filters) {

	return filters.reduce((result, filter) => {

		result[filter] = function(...args) {
			return this.$options.filters[filter](...args);
		};

		return result;

	}, {});

}



// WEBPACK FOOTER //
// ./sources/support/map/index.js